import { FooterExpressive, FooterGroup, Link, SystemIcon } from '@volvo/vcdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

// import ChangeLanguageModal from '@/components/modals/ChangeLanguageModal';
import { cookiePolicyLink, dealerLocatorLink, privacyPolicyLink } from '@/utils/baseLinks';

const PublicFooter: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <>
      <FooterExpressive>
        <FooterGroup title={t(($) => $.components.footer.useful)}>
          <Link href="https://www.volvopenta.com/your-engine/manuals-and-handbooks/">
            {t(($) => $.components.footer.manuals_and_handbooks)}
          </Link>
          <Link href={dealerLocatorLink}>{t(($) => $.components.footer.dealer_locator)}</Link>
          <Link href="https://www.volvopenta.com/industrial/services-and-solutions/protection-plans/warranty/">
            {t(($) => $.components.footer.warranty)}
          </Link>
        </FooterGroup>

        <FooterGroup title={t(($) => $.components.footer.parts_column)}>
          <Link href="https://www.volvopenta.com/industrial/industrial-engine-parts/">
            {t(($) => $.components.footer.parts)}
          </Link>
          <Link href="https://www.volvopenta.com/industrial/industrial-engine-parts/remanufacturing/">
            {t(($) => $.components.footer.remanufactured)}
          </Link>
        </FooterGroup>

        <FooterGroup title={t(($) => $.components.footer.contact)}>
          <Link href="https://www.volvopenta.com/your-engine/volvo-penta-action-service/">
            {t(($) => $.components.footer.action_service)}
          </Link>
          <Link href={`https://www.volvopenta.com/connect/faq`}>{t(($) => $.components.footer.faq)}</Link>
          <Link href="https://www.volvopenta.com/about-us/contact-us/">{t(($) => $.components.footer.contact_us)}</Link>
        </FooterGroup>

        <span slot="bar-start-edge" className="text-subtlest">
          {`© Copyright AB Volvo ${year}`}
        </span>

        <Link slot="bar-start-inner" href="https://www.volvogroup.com/" target="blank" variant="standalone-discreet">
          volvogroup.com
        </Link>
        <Link slot="bar-start-inner" href={privacyPolicyLink} target="blank" variant="standalone-discreet">
          {t(($) => $.components.footer.privacy_policy)}
        </Link>
        <Link slot="bar-start-inner" href={cookiePolicyLink} target="blank" variant="standalone-discreet">
          {t(($) => $.components.footer.cookie_policy)}
        </Link>

        <a slot="bar-end-inner" aria-label="Instagram" href="https://www.volvogroup.com/" target="blank">
          <SystemIcon icon="instagram" />
        </a>
        <a slot="bar-end-inner" aria-label="Facebook" href="https://www.volvogroup.com/" target="blank">
          <SystemIcon icon="facebook" />
        </a>
        <a slot="bar-end-inner" aria-label="YouTube" href="https://www.volvogroup.com/" target="blank">
          <SystemIcon icon="youtube" />
        </a>
        <a slot="bar-end-inner" aria-label="LinkedIn" href="https://www.volvogroup.com/" target="blank">
          <SystemIcon icon="linkedin" />
        </a>
      </FooterExpressive>
    </>
  );
};

export default PublicFooter;
